import { render } from "./TagContainer.vue?vue&type=template&id=2327cea0&scoped=true"
import script from "./TagContainer.vue?vue&type=script&lang=js"
export * from "./TagContainer.vue?vue&type=script&lang=js"

import "./TagContainer.vue?vue&type=style&index=0&id=2327cea0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2327cea0"]])

export default __exports__